<div *ngIf="isLoading">
	Loading
	<mat-icon>
		<mat-spinner diameter="18"> </mat-spinner>
	</mat-icon>
</div>
<div *ngIf="results.contactPersons.enabled">
	<h2>{{results.contactPersons.title}}</h2>
	<table class="table">
		<tr>
			<th class="active-date-width">Active Date</th>
			<th class="type-width">{{results.contactPersons.header}} Type</th>
			<th>{{results.contactPersons.header}}</th>
		</tr>
		<tr *ngFor="let current of results.contactPersons.current">
			<td>{{current.CREATED_DATE! | simpleDate}}</td>
			<td>{{current.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
			</td>
			<td> {{current.CONTACT_MECHANISMS!.CONTACT_PERSONS![0].FIRST_NAME}}
				{{current.CONTACT_MECHANISMS!.CONTACT_PERSONS![0].LAST_NAME}}</td>
		</tr>
	</table>

	<mat-accordion class="margin-horizontal-xs">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title class="danger">
					Past {{results.contactPersons.header}}(s) ({{results.contactPersons.past.length}})
				</mat-panel-title>
				<mat-panel-description>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<div class="scrollable-500">
				<table class="table">
					<tr>
						<th class="active-date-width">Active Date</th>
						<th class="type-width">{{results.contactPersons.header}} Type</th>
						<th>{{results.contactPersons.header}}</th>
					</tr>
					<tr *ngFor="let past of results.contactPersons.past">
						<td>{{past.CREATED_DATE! | simpleDate}}</td>
						<td>{{past.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
						</td>
						<td> {{past.CONTACT_MECHANISMS!.CONTACT_PERSONS![0].FIRST_NAME}}
							{{past.CONTACT_MECHANISMS!.CONTACT_PERSONS![0].LAST_NAME}}</td>
					</tr>
				</table>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>

<div *ngIf="results.postalAddresses.enabled">
	<h2>{{results.postalAddresses.title}}</h2>
	<table class="table">
		<tr>
			<th class="active-date-width">Active Date</th>
			<th class="type-width">{{results.postalAddresses.header}} Type</th>
			<th>{{results.postalAddresses.header}}</th>
		</tr>
		<tr *ngFor="let current of results.postalAddresses.current">
			<td>{{current.CREATED_DATE! | simpleDate}}</td>
			<td>{{current.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
			</td>
			<td>
				{{current.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_1}}
				{{current.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_2}}
				{{current.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.CITY_NAME}}
				{{current.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.STATE!.STATE_CODE}},
				{{current.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES!.POSTAL_CODE}}
			</td>
		</tr>
	</table>

	<mat-accordion class="margin-horizontal-xs">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title class="danger">
					Past {{results.postalAddresses.header}}(es) ({{results.postalAddresses.past.length}})
				</mat-panel-title>
				<mat-panel-description>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<div class="scrollable-500">
				<table class="table">
					<tr>
						<th class="active-date-width">Active Date</th>
						<th class="type-width">{{results.postalAddresses.header}} Type</th>
						<th>{{results.postalAddresses.header}}</th>
					</tr>
					<tr *ngFor="let past of results.postalAddresses.past">
						<td>{{past.CREATED_DATE! | simpleDate}}</td>
						<td>{{past.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
						</td>
						<td>
							{{past.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_1}}
							{{past.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_2}}
							{{past.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.CITY_NAME}}
							{{past.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.STATE!.STATE_CODE}},
							{{past.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES!.POSTAL_CODE}}
						</td>
					</tr>
				</table>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>

<div *ngIf="results.phoneNumbers.enabled">
	<h2>{{results.phoneNumbers.title}}</h2>
	<table class="table">
		<tr>
			<th class="active-date-width">Active Date</th>
			<th class="type-width">{{results.phoneNumbers.header}} Type</th>
			<th>{{results.phoneNumbers.header}}</th>
		</tr>
		<tr *ngFor="let current of results.phoneNumbers.current">
			<td>{{current.CREATED_DATE! | simpleDate}}</td>
			<td>{{current.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
			</td>
			<td>{{current.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].PHONE_NUMBER +
				(current.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT ? ' Ext. ' +
				current.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT : '')}}</td>
		</tr>
	</table>

	<mat-accordion class="margin-horizontal-xs">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title class="danger">
					Past {{results.phoneNumbers.header}}(s) ({{results.phoneNumbers.past.length}})
				</mat-panel-title>
				<mat-panel-description>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<div class="scrollable-500">
				<table class="table">
					<tr>
						<th class="active-date-width">Active Date</th>
						<th class="type-width">{{results.phoneNumbers.header}} Type</th>
						<th>{{results.phoneNumbers.header}}</th>
					</tr>
					<tr *ngFor="let past of results.phoneNumbers.past">
						<td>{{past.CREATED_DATE! | simpleDate}}</td>
						<td>{{past.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
						</td>
						<td>{{past.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].PHONE_NUMBER +
							(past.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT ? ' Ext. ' +
							past.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT : '')}}</td>
					</tr>
				</table>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>

<div *ngIf="results.emails.enabled">
	<h2>{{results.emails.title}}</h2>
	<table class="table">
		<tr>
			<th class="active-date-width">Active Date</th>
			<th class="type-width">{{results.emails.header}} Type</th>
			<th>{{results.emails.header}}</th>
		</tr>
		<tr *ngFor="let current of results.emails.current">
			<td>{{current.CREATED_DATE! | simpleDate}}</td>
			<td>{{current.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
			</td>
			<td>{{current.CONTACT_MECHANISMS!.EMAILS![0].EMAIL_ADDRESS}}</td>
		</tr>
	</table>

	<mat-accordion class="margin-horizontal-xs">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title class="danger">
					Past {{results.emails.header}}(s) ({{results.emails.past.length}})
				</mat-panel-title>
				<mat-panel-description>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<div class="scrollable-500">
				<table class="table">
					<tr>
						<th class="active-date-width">Active Date</th>
						<th class="type-width">{{results.emails.header}} Type</th>
						<th>{{results.emails.header}}</th>
					</tr>
					<tr *ngFor="let past of results.emails.past">
						<td>{{past.CREATED_DATE! | simpleDate}}</td>
						<td>{{past.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
						</td>
						<td>{{past.CONTACT_MECHANISMS!.EMAILS![0].EMAIL_ADDRESS}}</td>
					</tr>
				</table>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>